import * as React from 'react';

import localStorageEx from 'bundles/common/utils/localStorageEx';

export type EnterpriseAdminCoachProps = {
  currentTimePeriod: string;
  updateTimePeriod: (newTimePeriod: string) => void;
};

export const EnterpriseAdminCoachContext = React.createContext<EnterpriseAdminCoachProps>({
  currentTimePeriod: '',
  updateTimePeriod: () => {},
});

export const TIME_PERIOD_STORAGE_KEY = 'enterprise-admin-filters:time-period';
const DEFAULT_TIME_PERIOD = 'last_30_days';

export const EnterpriseAdminCoachProvider = ({ children }: React.PropsWithChildren) => {
  const [currentTimePeriod, setCurrentTimePeriod] = React.useState(() => {
    try {
      return localStorageEx.getItem(TIME_PERIOD_STORAGE_KEY, JSON.parse, DEFAULT_TIME_PERIOD);
    } catch {
      return DEFAULT_TIME_PERIOD;
    }
  });

  const updateTimePeriod = React.useCallback<(newTimePeriod: string) => void>(
    (newTimePeriod: string) => {
      if (newTimePeriod !== currentTimePeriod) {
        setCurrentTimePeriod(newTimePeriod);
        localStorageEx.setItem(TIME_PERIOD_STORAGE_KEY, newTimePeriod, JSON.stringify);
      }
    },
    [currentTimePeriod]
  );

  return (
    <EnterpriseAdminCoachContext.Provider
      value={{
        currentTimePeriod,
        updateTimePeriod,
      }}
    >
      {children}
    </EnterpriseAdminCoachContext.Provider>
  );
};

export const useEnterpriseAdminCoach = () => React.useContext(EnterpriseAdminCoachContext);
